import { useEffect, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import API from "../api/api";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function FeaturedSlider() {
    const [articles, setArticles] = useState([]);

    useEffect(() => {
        API
            .get("articles/latest?limit=5")
            .then((res) => setArticles(res.data || []))
            .catch((err) =>
                console.log("Error fetching latest articles:", err)
            );
    }, []);

    if (articles.length === 0) return null; // ⛔ avoid empty slider

    return (
        <div className="px-6 mt-4">
            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                navigation
                pagination={{ clickable: true }}
                autoplay={{ delay: 2000, disableOnInteraction: false }}
                loop={true}
                spaceBetween={20}
                className="rounded-lg overflow-hidden"
            >
                {articles.map((article) => (
                    <SwiperSlide key={article.slug}>
                        <Link to={`/article/${article.slug}`}>
                            <div className="relative cursor-pointer">

                                {/* IMAGE */}
                                <img
                                    src={
                                        article.images ||
                                        "https://via.placeholder.com/1200x600"
                                    }
                                    alt={article.title}
                                    className="w-full h-64 sm:h-80 md:h-[420px] object-cover rounded-lg"
                                />

                                {/* CATEGORY */}
                                <span className="absolute top-4 left-4 bg-black bg-opacity-70 text-white px-3 py-1 text-sm rounded">
                                    {article.category || "General"}
                                </span>

                                {/* TITLE OVERLAY */}
                                <div className="absolute bottom-0 left-0 bg-black bg-opacity-60 text-white p-4 w-full">
                                    <h2 className="text-lg sm:text-xl font-bold line-clamp-2">
                                        {article.title}
                                    </h2>
                                </div>

                            </div>
                        </Link>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
